import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = [
    'exportButton',
    'importButton',
    'importFile'
  ];

  connect() {
    this.frameLoaded();
  }

  async frameLoaded() {
    if (this.hasExportButtonTarget) {
      this.exportButtonTarget.disabled = true;
    }
  }

  rowClick({ currentTarget, params }) {
    this.playerId = params.id;
    this.teamId = params.teamId;

    if (this.hasExportButtonTarget) {
      this.exportButtonTarget.disabled = params.teamStatus != "active";
    }

    const scansSection = document.querySelector(".order_type_scans");

    if (scansSection) {
      fetch(`${window.location.pathname}?player_id=${this.playerId}`, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      .then(res => res.text())
      .then(html => {
        if (this.playerId == params.id) {
          const newDoc = new DOMParser().parseFromString(html, "text/html");
          const newTbody = newDoc.querySelector(".order_type_scans");
          scansSection.innerHTML = newTbody.innerHTML;
        }
      });
    }
  }

  exportClick({ params: { url } }) {
    location.href = `${url}?team_id=${this.teamId}`
  }

  importClick() {
    this.importFileTarget.click();
  }

  clearFile() {
    this.importFileTarget.value = null
  }
}
